// extracted by mini-css-extract-plugin
module.exports =  {"info":"info-nBG5H","brand":"brand-oCaZ8","shortcuts":"shortcuts-BlLGZ"};